function parseSmallFasta(text) {
    return text
        .split('>')
        .filter(t => /\S/.test(t))
        .map(entryText => {
        const [defLine, ...seqLines] = entryText.split('\n');
        const [id, ...description] = defLine.split(' ');
        const descriptionStr = description.join(' ');
        const seqLinesStr = seqLines.join('');
        const sequence = seqLinesStr.replaceAll(/\s/g, '');
        return { id, description: descriptionStr, sequence };
    });
}
export default class FastaMSA {
    constructor(text) {
        this.MSA = {
            seqdata: Object.fromEntries(parseSmallFasta(text).map(m => [`${m.id}`, m.sequence])),
        };
    }
    getMSA() {
        return this.MSA;
    }
    getRowData() {
        return undefined;
    }
    getNames() {
        return Object.keys(this.MSA.seqdata);
    }
    getRow(name) {
        var _a, _b;
        return (_b = (_a = this.MSA) === null || _a === void 0 ? void 0 : _a.seqdata[name]) === null || _b === void 0 ? void 0 : _b.split('');
    }
    getWidth() {
        var _a;
        const name = Object.keys((_a = this.MSA) === null || _a === void 0 ? void 0 : _a.seqdata)[0];
        return this.getRow(name).length;
    }
    getStructures() {
        return {};
    }
    get alignmentNames() {
        return [];
    }
    getHeader() {
        return {};
    }
    getTree() {
        return {
            id: 'root',
            name: 'root',
            noTree: true,
            branchset: this.getNames().map(name => ({
                id: name,
                branchset: [],
                name,
            })),
        };
    }
    get seqConsensus() {
        return undefined;
    }
    get secondaryStructureConsensus() {
        return undefined;
    }
    get tracks() {
        return [];
    }
}
//# sourceMappingURL=FastaMSA.js.map